import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/payments/payment_gateway_connections`;

const model = abstractModel(resource);

export default model;
